export enum Sounds {
  NEW_TICKET = 'NEW_TICKET',
  NEW_MESSAGE = 'NEW_MESSAGE',
}
